import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { APP_ROUTES } from '@taxora-business-core/util/constants/app-routes.constant';
import { AppState } from '@taxora-business-core/data-access/state/app.state';

export function createAuthGuard(options?: { withReturnUrl?: boolean }): CanActivateFn {
  return (_route, state: RouterStateSnapshot) => {
    const store = inject(Store);
    const accessToken = store.selectSnapshot(AppState.accessToken);

    if (!accessToken) {
      const router = inject(Router);
      const extras = options?.withReturnUrl ? { queryParams: { returnUrl: state.url } } : {};
      router.navigate([APP_ROUTES.AUTH.ROOT, APP_ROUTES.AUTH.LOGIN], extras);
      return false;
    }

    return true;
  };
}

export const anonGuard: CanActivateFn = createAuthGuard();
